import { NorceWarehouseCodes } from '#constants/norceCodes';
import { useGlobalContentStore } from '~/store/globalContent';
import { StockStatus } from '#constants/types/algolia';
import { ProductVariantModel } from '#models/productVariant';

export default function useWarehouse() {
  const globalContent = useGlobalContentStore();

  const getWarehouseCode = (): string => {
    return globalContent.getCountryCode === 'us'
      ? NorceWarehouseCodes.US
      : NorceWarehouseCodes.Standard;
  };

  const getStockStatusForWarehouse = (stockStatuses: StockStatus[]): StockStatus | null => {
    const warehouseCode = getWarehouseCode();
    return stockStatuses.find(st => st.warehouse.code === warehouseCode) ?? null;
  };

  const getStockValue = (stockStatuses: StockStatus[]): number => {
    const stockStatus = getStockStatusForWarehouse(stockStatuses);
    return stockStatus?.inStock ?? 0;
  };

  /* Get stock value for a variant */
  const getVariantStockValue = (variant: ProductVariantModel): number => {
    return variant.getStockValueByWarehouse(getWarehouseCode());
  };

  /* Get stock status for a variant */
  const getVariantStockStatus = (variant: ProductVariantModel): StockStatus | null => {
    return variant.getStockStatusByWarehouse(getWarehouseCode());
  };

  return {
    getWarehouseCode,
    getStockStatusForWarehouse,
    getStockValue,
    getVariantStockValue,
    getVariantStockStatus,
  };
}
